const envUrl = process.env.VUE_APP_CURRENTMODE
// process.env.VUE_APP_CURRENTMODE
export default {
    dcApis () {
        if (envUrl === "dev") {
            return "/dcApis"
        } else if (envUrl === "test") {
            return "https://test-dc.jihai8.com"
        } else {
            return "https://dc.jihai8.com"
        }
    },
    apis () {
        if (envUrl === "dev") {
            return "/apis"
        } else if (envUrl === "test") {
            return "https://test-news.jihai8.com"
        } else {
            return "https://news.jihai8.com"
        }
    },
    passportApis () {
        if (envUrl === "dev") {
            return "/passportApis"
        } else if (envUrl === "test") {
            return "https://test-passport.jihai8.com"
        } else {
            return "https://passport.jihai8.com"
        }
    },
    commentApis () {
        if (envUrl === "dev") {
            return "/commentApis"
        } else if (envUrl === "test") {
            return "https://test-comment.jihai8.com"
        } else {
            return "https://comment.jihai8.com"
        }
    },
    shareApis () {
        if (envUrl === "dev") {
            return "/shareApis"
        } else if (envUrl === "test") {
            return "https://test-passport.jihai8.com"
        } else {
            return "https://passport.jihai8.com"
        }
    },
    djApis () {
        if (envUrl === "dev") {
            return "/djApis"
        } else if (envUrl === "test") {
            return "https://djdata.jihai8.com"
        } else {
            return "https://djdata.jihai8.com"
        }
    },
    mApis () {
        if (envUrl === "dev") {
            return "/mApis"
        } else if (envUrl === "test") {
            return "https://test-mapi.jihai8.com"
        } else {
            return "https://mapi.jihai8.com"
        }
    },
    bbsApis () {
        if (envUrl === "dev") {
            return "/bbsApis"
        } else if (envUrl === "test") {
            return "https://test-api-bbs.jihai8.com"
        } else {
            return "https://api-bbs.jihai8.com"
        }
    }
}
